var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse0, _ellipse1, _ellipse10, _ellipse11, _circle, _circle2, _circle3, _path10, _circle4, _circle5, _circle6, _path11, _circle7, _circle8, _circle9, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSportMarketing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1407,
    height: 1400,
    viewBox: "0 0 1407 1400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M612.695 779.392L602.651 877.436",
    stroke: "white",
    strokeWidth: 11.4783,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M853.261 793.261L848 892.74",
    stroke: "white",
    strokeWidth: 11.4783,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M500.304 808.566C516.086 844.914 592.111 898.668 727 905.653C874.782 913.305 926.116 866.754 942.217 846.827",
    stroke: "white",
    strokeWidth: 19.1304,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1066.09 962.566C1078.2 979.783 1101.1 1026.56 1095.74 1075.91",
    stroke: "white",
    strokeWidth: 19.1304,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1100.52 864.044C1116.3 870.74 1148.54 892.74 1151.22 927.175",
    stroke: "white",
    strokeWidth: 19.1304,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M651.434 637.348C616.043 640.218 544.782 656.288 542.869 697.609C540.955 738.931 642.187 765.522 693.043 773.653",
    stroke: "white",
    strokeWidth: 12.4348,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M789.174 776.044C827.435 776.522 908.835 765.331 928.348 716.74",
    stroke: "white",
    strokeWidth: 12.4348,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M604.087 63.913C616.713 41.339 637.725 55.7825 646.652 65.826C660.043 42.4869 681.565 46.2173 687.783 56.2608C702.704 86.4869 663.391 119.232 641.87 131.826C624.014 118.594 591.461 86.4869 604.087 63.913Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3499 834.137C63.4196 813.644 84.0737 809.684 95.1421 810.265C89.2062 788.88 103.869 778.411 113.366 780.583C139.753 789.344 136.186 831.394 131.104 851.324C112.99 854.134 75.2803 854.63 69.3499 834.137Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M556.329 138.386C534.696 120.174 540.483 64.8819 548.081 30.0972C549.63 23.0061 556.197 18.2955 563.444 18.7074L727.878 28.0551C733.004 28.3465 737.738 31.1487 739.829 35.8374C756.031 72.1556 745.907 122.416 735.87 151.62C733.644 158.1 727.085 161.862 720.284 161.033L682.642 156.442C676.734 155.722 670.944 158.492 667.798 163.545L645.29 199.694C643.651 202.326 639.725 202.018 638.518 199.162L619.991 155.34C617.846 150.266 613.14 146.736 607.668 146.098L562.578 140.837C560.308 140.572 558.078 139.858 556.329 138.386Z",
    stroke: "white",
    strokeWidth: 18.1739,
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4062 905.272C59.1802 907.413 30.0842 871.971 14.0738 847.352C10.81 842.333 11.8514 835.749 16.2932 831.735L117.08 740.65C120.222 737.811 124.61 736.657 128.574 738.147C159.278 749.688 182.907 784.759 194.229 807.574C196.741 812.636 195.148 818.666 190.72 822.176L166.21 841.607C162.363 844.657 160.633 849.661 161.775 854.435L169.945 888.596C170.54 891.083 168.083 893.208 165.707 892.261L129.252 877.736C125.031 876.054 120.232 876.771 116.686 879.612L87.4659 903.025C85.9949 904.204 84.2834 905.099 82.4062 905.272Z",
    stroke: "white",
    strokeWidth: 14.9901,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 541.023,
    cy: 557.783,
    rx: 10.0435,
    ry: 36.3479,
    transform: "rotate(-34.2579 541.023 557.783)",
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1032.41,
    cy: 731.627,
    rx: 10.0435,
    ry: 44.0538,
    transform: "rotate(85.0109 1032.41 731.627)",
    fill: "white"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1020.4,
    cy: 818.239,
    rx: 10.0435,
    ry: 44.0538,
    transform: "rotate(103.028 1020.4 818.239)",
    fill: "white"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 602.584,
    cy: 510.433,
    rx: 12.8773,
    ry: 70.3695,
    transform: "rotate(-22.353 602.584 510.433)",
    fill: "white"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 821.012,
    cy: 490.976,
    rx: 12.8773,
    ry: 90.0422,
    transform: "rotate(19.2772 821.012 490.976)",
    fill: "white"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1043.73,
    cy: 621.605,
    rx: 12.8773,
    ry: 90.0422,
    transform: "rotate(66.3976 1043.73 621.605)",
    fill: "white"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 796.622,
    cy: 1026.7,
    rx: 12.8773,
    ry: 90.0422,
    transform: "rotate(-14.2931 796.622 1026.7)",
    fill: "white"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 672.801,
    cy: 1000.07,
    rx: 12.8773,
    ry: 73.2019,
    transform: "rotate(10.0936 672.801 1000.07)",
    fill: "white"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 544.889,
    cy: 972.416,
    rx: 12.8773,
    ry: 73.2019,
    transform: "rotate(40.7009 544.889 972.416)",
    fill: "white"
  })), _ellipse0 || (_ellipse0 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 465.647,
    cy: 911.705,
    rx: 12.8773,
    ry: 64.1139,
    transform: "rotate(56.3748 465.647 911.705)",
    fill: "white"
  })), _ellipse1 || (_ellipse1 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 884.419,
    cy: 986.236,
    rx: 12.8773,
    ry: 64.1139,
    transform: "rotate(145.74 884.419 986.236)",
    fill: "white"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 968.212,
    cy: 520.3,
    rx: 13.8517,
    ry: 115.818,
    transform: "rotate(46.9155 968.212 520.3)",
    fill: "white"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 679.741,
    cy: 451.02,
    rx: 12.8773,
    ry: 117.699,
    transform: "rotate(-8.30398 679.741 451.02)",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 281.738,
    cy: 436.957,
    r: 14.3478,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 330.521,
    cy: 418.783,
    r: 14.3478,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 380.26,
    cy: 404.435,
    r: 14.3478,
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M420.551 311.625C328.619 327.638 235.832 368.743 194.11 390.83C189.912 393.052 186.992 397.134 187.122 401.881C187.921 430.986 211.956 481.673 228.799 512.317C232.27 518.631 239.757 521.448 246.606 519.212L320.504 495.082C325.542 493.436 331.073 494.515 335.124 497.933L368.775 526.327C377.951 534.069 392.062 528.713 393.79 516.833L400.031 473.927C400.818 468.512 404.438 463.929 409.523 461.908L465.222 439.771C471.554 437.254 475.505 430.845 474.552 424.098C467.478 374.046 447.413 335.638 434.268 317.039C431.183 312.674 425.817 310.708 420.551 311.625Z",
    stroke: "white",
    strokeWidth: 18.1739,
    strokeLinecap: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 992.49,
    cy: 249.004,
    r: 11.4037,
    transform: "rotate(43.3356 992.49 249.004)",
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 1030.6,
    cy: 265.106,
    r: 11.4037,
    transform: "rotate(43.3356 1030.6 265.106)",
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 1067.19,
    cy: 283.942,
    r: 11.4037,
    transform: "rotate(43.3356 1067.19 283.942)",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1141.1 252.265C1079.22 211.378 1003.16 184.53 966.993 174.541C963.355 173.536 959.44 174.303 956.925 177.119C941.512 194.38 927.76 236.792 920.782 263.694C919.344 269.237 922.136 274.949 927.315 277.392L983.197 303.75C987.007 305.547 989.616 309.187 990.093 313.373L994.06 348.142C995.141 357.623 1006.22 362.223 1013.7 356.298L1040.71 334.898C1044.12 332.197 1048.71 331.522 1052.75 333.128L1097.03 350.711C1102.06 352.71 1107.84 351.16 1110.97 346.74C1134.18 313.947 1143.53 280.798 1146.08 262.877C1146.67 258.671 1144.64 254.607 1141.1 252.265Z",
    stroke: "white",
    strokeWidth: 14.4446,
    strokeLinecap: "round"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 267.957,
    cy: 1187.68,
    r: 12.3929,
    transform: "rotate(-25.6606 267.957 1187.68)",
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 299.141,
    cy: 1155.28,
    r: 12.3929,
    transform: "rotate(-25.6606 299.141 1155.28)",
    fill: "white"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 332.498,
    cy: 1125.51,
    r: 12.3929,
    transform: "rotate(-25.6606 332.498 1125.51)",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M329.152 1038.18C263.567 1085.03 206.701 1151.74 182.479 1184.54C180.042 1187.84 179.295 1192.11 181.173 1195.76C192.681 1218.12 230.353 1248.59 254.928 1266.15C259.992 1269.77 266.874 1269.16 271.37 1264.86L319.879 1218.43C323.186 1215.27 327.896 1214.04 332.328 1215.18L369.148 1224.7C379.188 1227.3 388.171 1217.85 385.072 1207.96L373.883 1172.22C372.471 1167.71 373.574 1162.78 376.778 1159.31L411.863 1121.24C415.852 1116.91 416.53 1110.45 413.264 1105.55C389.036 1069.23 359.047 1046.83 341.857 1037.26C337.822 1035.02 332.909 1035.5 329.152 1038.18Z",
    stroke: "white",
    strokeWidth: 15.6977,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1084.26 901.349C1031.65 1027.13 983.826 1077.67 945.565 1092.65L593.096 1184.03C587.135 1185.58 581.574 1188.59 577.535 1193.23C534.29 1242.99 550.374 1313.68 571.133 1358.56C577.864 1373.12 594.654 1379.16 609.966 1374.4L914.478 1279.65C1008.6 1243.31 1066.88 1152.6 1084.26 1111.78L1394.9 317.675C1396.94 312.459 1397.96 306.744 1396.47 301.345C1390.53 279.799 1371.3 274.876 1354.77 275.775C1344.13 276.353 1335.88 284.379 1331.86 294.243L1084.26 901.349Z",
    stroke: "white",
    strokeWidth: 19.1304,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M501.525 686.073C510.578 644.631 575.048 578.055 748.763 596.28C835.565 605.387 889.202 625.737 921.293 648.407C953.099 670.875 964.43 696.293 963.742 714.944C964.072 732.535 950.703 757.194 917.467 776.459C883.78 795.986 828.936 810.597 743.514 808.084C572.824 803.064 510.383 731.687 501.449 692.121C501.255 691.265 501.216 690.41 501.309 689.584C501.203 688.438 501.267 687.257 501.525 686.073ZM746.368 619.111C577.267 601.371 529.249 666.732 523.953 690.972C526.168 689.376 523.325 693.849 523.953 690.972C519.913 722.001 591.803 788.312 743.965 792.787C827.656 795.249 879.384 780.844 909.792 763.218C932.387 750.121 942.827 735.569 946.638 724.832C950.348 706.218 935.817 686.774 908.047 667.157C880.324 647.573 830.974 627.987 746.368 619.111Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M510.825 693.305L499.825 805.696",
    stroke: "white",
    strokeWidth: 19.1304,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M952.421 732.412L943.97 845.024",
    stroke: "white",
    strokeWidth: 16.2609,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M511.782 750.696C523.42 764.247 559.226 793.548 609.348 802.349",
    stroke: "white",
    strokeWidth: 11.4783,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M949.391 772.696C937.753 786.247 901.947 815.548 851.825 824.349",
    stroke: "white",
    strokeWidth: 11.4783,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M508.435 770.783C520.072 784.334 555.878 813.635 606 822.435",
    stroke: "white",
    strokeWidth: 11.4783,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M949.869 792.783C938.231 806.334 902.426 835.635 852.304 844.435",
    stroke: "white",
    strokeWidth: 11.4783,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M504.608 793.74C516.246 807.29 552.052 836.592 602.174 845.392",
    stroke: "white",
    strokeWidth: 11.4783,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M943.652 819.566C932.015 833.117 903.383 858.592 853.261 867.392",
    stroke: "white",
    strokeWidth: 11.4783,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M658.13 1167.26C677.898 1188.62 700.982 1264.73 682.999 1350.44",
    stroke: "white",
    strokeWidth: 34.4348
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M686.64 1159.85C708.894 1178.61 741.196 1251.29 733.93 1338.56",
    stroke: "white",
    strokeWidth: 34.4348
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M779.13 1145.74C818.95 1162.31 864.549 1211.44 841.304 1300.7",
    stroke: "white",
    strokeWidth: 34.4348
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M890.565 1112.74C915.912 1153.39 912.086 1112.74 956.565 1263.39",
    stroke: "white",
    strokeWidth: 34.4348
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M772.913 1137.61C784.551 1188.94 799.217 1242.83 785.348 1322.7",
    stroke: "white",
    strokeWidth: 26.7826
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M884.348 1104.61C895.985 1155.94 910.652 1209.83 896.782 1289.7",
    stroke: "white",
    strokeWidth: 26.7826
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSportMarketing);
export default __webpack_public_path__ + "static/media/sport-marketing.6f3e82e7ac077edcdb3313342ab91dc6.svg";
export { ForwardRef as ReactComponent };